import { AbstractSelfAccountKeyring } from '../../../keyring/account_base';
import { AbstractConfigDumpArgs, AbstractConfigLoadArgs } from '../../base';

function _check_variant_key_consistency(key_version: string, variant: string) {
  if (
    (key_version === AbstractSelfAccountKeyring.MLKEM1024 ||
      key_version === AbstractSelfAccountKeyring.MLDSA87) &&
    variant !== AbstractSelfAccountKeyring.VARIANT_ML
  ) {
    throw new Error('ML keys must be used with ML keyring variant');
  }
}

export class AccountRootKeyConfigLoadArgs extends AbstractConfigLoadArgs {
  public self_kr;
  public key_version;
  public variant;

  constructor(
    cipher: Uint8Array,
    self_kr: AbstractSelfAccountKeyring,
    key_version: string,
    variant?: string
  ) {
    super(cipher);
    this.self_kr = self_kr;
    this.key_version = key_version;
    // NOTE: This is supplied as an argument by the loading logic, as the self_kr does not yet hold the keys
    //       to indicate its real variant state.
    this.variant = variant || AbstractSelfAccountKeyring.VARIANT_BASE;
    _check_variant_key_consistency(this.key_version, this.variant);
  }
}

export class AccountRootKeyConfigDumpArgs extends AbstractConfigDumpArgs {
  public self_kr;
  public key_version;
  public variant;

  constructor(self_kr: AbstractSelfAccountKeyring, key_version: string) {
    super();
    this.self_kr = self_kr;
    this.key_version = key_version;
    this.variant = self_kr.get_variant();
    _check_variant_key_consistency(this.key_version, this.variant);
  }
}
